var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog150',{ref:"timeLineSetup-set",staticClass:"form-table-h360",attrs:{"title":"时间轴设置","data":_vm.timeLineSetupInfo,"width":"50%","labelWidth":"200","visible":_vm.visibleSync,"columns":_vm.ColumnList},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.save}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf7ea77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scheduling/TimeLineSetup.vue
// module id = null
// module chunks = 